export const SOCIAL_LISTENING_ANALYTICS_TOPIC_FILTERS =
  'socialListeningAnalyticsTopicFilters';
export const SOCIAL_LISTENING_ANALYTICS_BRAND_FILTERS =
  'socialListeningAnalyticsBrandFilters';
